import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";
import FieldsReport from 'graphql/fields/FieldsReport'

const fields = {
	'guid': 'String',
	'email': 'String',
	'type': 'String',
	'time': 'String',
	'for_date': 'String',
	'language_guid': 'String',
	'building_guid': 'String',
	'timeslot_kind_guid': 'String',
	'active': 'String!',
};

export default gql(`
	mutation report( ${ HelperGraphql.createFields( fields ) } ) {
	    report( ${ HelperGraphql.createVariables( fields ) } ) {
	       ${FieldsReport}
	    }
	}
`);

